import "./locally-widget.scss";
import { PageComponent } from "barba";

const reloadTimeoutMs = 1000;
const cookieConsentLevel = "necessary"; // No cookies yet

class LocallyWidget {
    constructor({ node }) {
        this.node = node;
        this.config = {
            upc: node.dataset.locallyWidgetUpc,
            companyId: node.dataset.locallyWidgetCompanyId,
            locale: node.dataset.locallyWidgetLocale,
            buttonText: node.dataset.locallyWidgetButtonText,
            btnEndpointUrl: `${node.dataset.locallyWidgetBaseUrl}/stores/map.js`,
            switchLiveEndpointUrl: `${node.dataset.locallyWidgetBaseUrl}/js/switchlive.js`,
            switchLiveEventsEndpointUrl: `${node.dataset.locallyWidgetBaseUrl}/switchlive/switchlive-events.js`
        };

        this.mobileClickListener = function (e) {
            if (e.target.hasAttribute("data-locally-button-mobile")) {
                document.querySelector("#lcly-link-0")?.click();
            }
        };
        document.addEventListener("click", this.mobileClickListener);

        this.log(`Locally widget constructor for upc: ${this.config.upc}`);

        const onReady = () => {
            if (!this.ensureCookieConsent()) return;

            if (!this.isLocallyInitialized()) {
                this.initLocally();
            } else {
                this.reloadLocally();
            }
        };

        // Make sure cookieyes has loaded
        this.waitForReady(onReady);
    }

    waitForReady(callback) {
        if (document.readyState === "complete") {
            callback();
        } else {
            const interval = setInterval(() => {
                if (document.readyState === "complete") {
                    clearInterval(interval);
                    callback();
                }
            }, 100);
        }
    }

    ensureCookieConsent() {
        // CookieYes is only available on domain www.devinci.com
        if (!window.getCkyConsent) return true;

        const consent = window.getCkyConsent();

        if (!!consent?.categories[cookieConsentLevel]) return true;

        this.log("Locally widget will not be activated because the user did not give consent for cookies.");
        this.node.style.display = "none";
        return false;
    }

    isLocallyInitialized() {
        const initialized = !!window.sig_locally_initialized;
        this.log(`window.sig_locally_initialized: ${initialized}`);
        return initialized;
    }

    initLocally() {
        this.log("Locally widget initializing...");

        ////////////////////////////////////////
        // Extracted from the locally widget
        ////////////////////////////////////////
        const lcly_config = {
            company_name: "Devinci",
            button_text: `${this.config.buttonText}`,
            company_id: `${this.config.companyId}`,
            css: "4",
            upc: `${this.config.upc}`,
            show_location_switcher: "0",
            show_location_prompt: "0",
            lang: `${this.config.locale}`,
            always_hide_button: "1",
            n_buy_online_results: "3",
            show_dealers: "1",
            n_dealers: "3",
            show_address: "1",
            show_phone: "1",
            link_opens_modal: "1"
        };

        const lcly_query = Object.keys(lcly_config)
            .reduce(function (a, k) {
                a.push(
                    encodeURIComponent(k) +
                        "=" +
                        encodeURIComponent(
                            typeof lcly_config[k] === "object" && lcly_config[k] !== null
                                ? JSON.stringify(lcly_config[k])
                                : lcly_config[k]
                        )
                );
                return a;
            }, [])
            .join("&");

        const appendScript = (id, src) => {
            const s = document.createElement("script");
            s.id = id;
            s.async = true;
            s.src = src;
            this.node.appendChild(s);
        };

        setTimeout(() => {
            appendScript("lcly-script-0", `${this.config.btnEndpointUrl}?${lcly_query}`);
            appendScript("lcly-script-switchlive-0", `${this.config.switchLiveEndpointUrl}?company_id=${this.config.companyId}`);
            appendScript(
                "lcly-script-switchlive-events-0",
                `${this.config.switchLiveEventsEndpointUrl}?company_id=${this.config.companyId}`
            );

            window.sig_locally_initialized = true;
            this.log("Locally widget initialized.");
        }, reloadTimeoutMs);
    }

    reloadLocally() {
        const upc = this.config.upc;
        this.log(`Locally widget reloading for upc: ${upc}`);

        // https://support.locally.com/en/support/solutions/articles/14000099711-product-locator-reload
        const reload = () => lcly_reload_0({ upc: upc });

        setTimeout(() => {
            reload();
            this.log(`Locally reloaded for upc: ${upc}`);
        }, reloadTimeoutMs);
    }

    destroy() {
        this.log(`Locally widget destroy for upc: ${this.config.upc}`);
        document.removeEventListener("click", this.mobileClickListener);
        delete this.node;
        delete this.config;
        delete this.mobileClickListener;
    }

    log(args) {
        if (process.env.NODE_ENV !== "development") return;

        console.log(args);
    }
}

new PageComponent("[data-locally-widget]", LocallyWidget);
